import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import cx from 'classnames';

// Utils
import { routes } from '@routes';

// UI
import { Link } from '@components/link';
import { NavbarActions } from './navbar-actions';
interface NavbarProps {
  isConstrained?: boolean;
  isSticky?: boolean;
  centerContent?: React.ReactNode;
}

/**
 * Composable navbar component with full-width border/shadow and optional content constraint.
 * Session handling is pushed down to NavbarActions (client component).
 *
 * Usage:
 * - Most pages: <Navbar /> (constrained by default)
 * - Search page: <Navbar isConstrained={false} centerContent={<SearchSummary />} />
 */
export const Navbar: React.FC<NavbarProps> = t0 => {
  const $ = _c(14);
  const {
    isConstrained: t1,
    isSticky: t2,
    centerContent
  } = t0;
  const isConstrained = t1 === undefined ? true : t1;
  const isSticky = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== isSticky) {
    t3 = cx("w-full border-b border-gray-light shadow-sm bg-white", {
      "sticky top-0 z-50": isSticky
    });
    $[0] = isSticky;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = isConstrained ? "body-container" : "px-4 sm:px-8";
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Link to={routes.home}><img src="/assets/svg/logos/savvy_wordmark_slate.svg" className="block h-10 w-auto" alt="Savvy" /></Link>;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] !== centerContent) {
    t6 = centerContent && <div className="hidden sm:flex">{centerContent}</div>;
    $[3] = centerContent;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <NavbarActions />;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t6) {
    t8 = <div className="py-4 sm:py-6 relative flex items-center justify-between">{t5}{t6}{t7}</div>;
    $[6] = t6;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== t4 || $[9] !== t8) {
    t9 = <div data-id="navbar-container" className={t4}>{t8}</div>;
    $[8] = t4;
    $[9] = t8;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t3 || $[12] !== t9) {
    t10 = <nav aria-label="Main navigation" className={t3}>{t9}</nav>;
    $[11] = t3;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
};